<template id="">
  <div
  :class="`
    dashboard-workpackage
    ${color}
    ${text_color}--text
    ${color.includes('lighten') || color.includes('darken')? '':'lighten-1'}
    t-rounded
    t-shadow
    font-weight-light

    `"

  :style="`
  ${height?`height: ${height}px;`:''}
  ${width?`width: ${width}px;`: ''}
  ${margin?`margin: ${margin}px;`:''}
  `"

  >

    <!-- <div class="workbench-workpackage-header-vertical">
      <slot name="header-vertical"/>
    </div> -->
    <div class="workbench-workpackage-header">
      <slot name="header"/>
    </div>
    <div
      class="workbench-workpackage-content"

      >
      <slot name="content"/>
    </div>
      <v-spacer/>
      <div
      class="workbench-workpackage-footer"
      >
        <slot name="footer"/>
      </div>
  </div>
</template>

<script>
  export default {
    props: [
      'color',
      'text_color',
      'height',
      'width',
      'margin',
      'tabs',
      'no_header',
      'footer',
      'center_content'
    ]
  }
</script>

<style>

  .dashboard-workpackage {
    cursor: pointer;
    height: 65px;
    width: 100px;
    display: flex;
    flex-direction: column;
    /* padding: 3px; */

  }
  .workbench-workpackage-header {
    font-size: 13px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding-left: 3px;

  }
  .workbench-workpackage-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 3px;
    /* justify-content: center; */
    /* margin-bottom: -5px; */

  }
  .workbench-workpackage-footer{
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
